import { render, staticRenderFns } from "./formSocialPractive.vue?vue&type=template&id=7189759c&scoped=true&"
import script from "./formSocialPractive.vue?vue&type=script&lang=js&"
export * from "./formSocialPractive.vue?vue&type=script&lang=js&"
import style0 from "./formSocialPractive.vue?vue&type=style&index=0&id=7189759c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7189759c",
  null
  
)

export default component.exports